import { navigateTo } from "nuxt/app";

/**
 * 适配多语言跳转
 * @param url   跳转的路径url
 * @param param 跳转参数目前只支持/的传参
 */
export const routeGo = (url: string, param: string = '', query: any = {}) => {
	// @ts-ignore
	const localeRoute = useLocaleRoute();
	const routePath = localeRoute({
		path: '/' + url + '/' + param,
		query: query
	});
	if (routePath) {
		navigateTo(routePath.fullPath); // 路由跳转
	}
};
/**
 *
 * @param route  路由
 * @param localeRoute  多语言路由
 * @param language   要修改的语言
 */
export const changeLanguageRoute = (route: { path: string; query: any; }, localeRoute: (arg0: { path: string; query: any; }) => any, language: string) => {
	console.log(route.path);
	const pathName = route.path.substring(4);
	const routePath = localeRoute({ path: '/' + language + '/' + pathName, query: { ...route.query } });
	if (routePath) {
		navigateTo(routePath.fullPath); // 路由跳转
	}
	// setTimeout(() => {
	// 	window.location.reload();
	// }, 400);
};
